import { createContext, useContext } from 'react';
/** @internal Context for menu components to share state and actions. */
export const MenuContext = createContext(null);
export function useMenuContext() {
    return useContext(MenuContext);
}
export function useMenuClose() {
    return useMenuContext()?.closeMobileMenu;
}
//# sourceMappingURL=useMenuContext.js.map